<template>
  <div class="news-template">
    <div class="header"></div>
    <div class="title">
      <h3>中国物品编码中心广西分中心赴广西威利方舟科技有限公司开展UDI调研工作</h3>
      <h5>2020-09-24 11:09:19 中国物品编码中心广西分中心 聂晓宇 <i class="el-icon-reading"></i>264</h5>
    </div>
    <el-divider></el-divider>
    <div class="content">
      <div class="acticle-content" style="padding: 15px;">
               <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255);">为深入了解医疗器械唯一标识（UDI）的应用情况，近日，中国物品编码中心广西分中心赴广西威利方舟科技有限公司开展调研工作，实地了解企业在实施UDI过程中的问题和需求。</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255);">调研中，威利方舟负责人介绍了公司当前商品条码的使用、UDI编码情况及使用中发现的问题等。广西分中心技术人员对该公司每个生产部件均有内部编码的规范操作表示肯定，同时指出内部编码与外部的销售商、医疗机构等系统不能兼容会造成设备不能全生命周期一码追溯问题，建议公司所有部件使用基于GS1标准实现医疗器械的唯一标识编码。</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255);">本次调研提高了医疗器械企业对UDI的重视程度，今后，广西分中心将继续深入企业，进一步推进GS1标准的编码体系在医疗行业的应用。</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255); text-align: center;"><img title="20200916010101.jpg" alt="20200916010101.jpg" src="/images/news2.jpg" style="box-sizing: border-box; border: 0px; vertical-align: middle; display: block; max-width: 100%; height: auto; margin: 0px auto;" data-catchresult="img_catchSuccess"></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255); text-align: right;">（编辑：黄雪松）</p><p><br></p>
               </div>
    </div>
    <div class="newsfooter"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contentText: `&nbsp;&nbsp;本报济南4月17日电  （记者徐锦庚、李蕊）今年是胜利油田发现60周年。位于黄河入海口的胜利油田迄今累计生产原油12.5亿吨，占全国同期陆上原油产量1/5，目前保持年稳产2340万吨以上。`,
    };
  },
};
</script>
<style lang="scss" scoped>
.news-template {
  text-align: center;
  width: 100%;
  font-family: Hiragino Sans GB, Microsoft Yahei, \\5fae\8f6f\96c5\9ed1, SimSun,
    \\5b8b\4f53, Arial;
  .header {
    height: 6em;
    background: #04c9a0;
  }
  h3 {
    font-size: 1.7em;
    margin: 0.7em 0;
  }
  h5 {
    margin: 0.5em 0;
    color: #909399;
  }
  .content {
    width: 75%;
    margin: 0 12%;
    p {
      font-size: 1.2em;
      text-align: left;
      line-height: 2.2;
      margin-bottom: 2em;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }
  }
}
</style>